import { createSelector } from 'reselect';

import { FLAG_KEYS } from 'lib/constants';
import { getLaunchDarklyFlags } from './getLaunchDarklyFlags';

const getMachineManualPartCountEnabled = createSelector(
  [getLaunchDarklyFlags],
  (flags) => {
    return flags?.[FLAG_KEYS.MACHINE_MANUAL_PART_COUNT_ENABLED];
  }
);

export { getMachineManualPartCountEnabled };
